import Reveal from "./Reveal";
import { ArrowUpRight, Clock } from "lucide-react";
import { SITE } from "../config/siteConfig";

export default function Reservation() {
  return (
    <section id="kontakt" className="py-16 md:py-28" data-testid="section-reservation">
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <Reveal>
          <div className="relative overflow-hidden rounded-lg bg-brand-red px-6 py-12 text-paper sm:px-12 md:px-16 md:py-20">
            <svg
              aria-hidden="true"
              viewBox="0 0 16 16"
              className="pointer-events-none absolute -right-10 -top-10 h-56 w-56 opacity-15 md:h-72 md:w-72"
            >
              <circle cx="8" cy="8" r="6.6" fill="none" stroke="#F0EAE0" strokeWidth="1" />
              <path
                d="M1.4 8h13.2M8 1.4v13.2M3.5 3.7a9 9 0 0 1 0 8.6M12.5 3.7a9 9 0 0 0 0 8.6"
                stroke="#F0EAE0"
                strokeWidth="0.8"
                fill="none"
              />
            </svg>

            <p className="eyebrow text-paper/80">
              <span className="inline-block h-[3px] w-10 shrink-0 bg-paper" aria-hidden="true" />
              Reservation &amp; Besuch
            </p>
            <h2 className="h2 mt-4 text-paper">Dein Platz in der Hitsstube</h2>
            <p className="mt-5 max-w-[56ch] text-base leading-relaxed text-paper/90 md:text-lg">
              {SITE.reservationText}
            </p>
            <a
              data-testid="reservation-button"
              href={SITE.reservationMailto}
              className="mt-8 inline-flex min-h-[48px] items-center gap-2 rounded-md bg-paper px-8 text-base font-bold text-ink transition-all duration-200 hover:-translate-y-0.5 hover:bg-paperlight"
            >
              Reservation anfragen
              <ArrowUpRight className="h-5 w-5" aria-hidden="true" />
            </a>
            <p className="mt-8 font-semibold">{SITE.reservationAddress}</p>
            <p className="mt-1 flex items-center gap-2 text-sm text-paper/85">
              <Clock className="h-4 w-4" aria-hidden="true" />
              {SITE.reservationHint}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
